import React from 'react';
import Project_overview from '../pages/Project_overview';
import cccc from '../images/cccc.png';
import ed2 from '../images/ed2.png';
import sbd from '../images/sbd.png';
import '../css/BlockDiagram.css'; // Import your external CSS

const BlockDiagram = () => {
  return (
    <div>
      <Project_overview />

      <div className="block-diagram">
        <div className="diagram-item">
          <h1>Experimental Block Diagram (D1)</h1>
          <img src={cccc} alt="block diagram" className="diagram-image cccc" />
        </div>
        
        <div className="diagram-item">
          <h1>Experimental Block Diagram (D2)</h1>
          <img src={ed2} alt="block diagram" className="diagram-image ed2" />
        </div>

        <div className="diagram-item">
          <h1>Hardware Schematic Block Diagram</h1>
          <img src={sbd} alt="block diagram" className="diagram-image sbd" />
        </div>
      </div>



     


    </div>
  );
}

export default BlockDiagram;
